import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './student-box.scss';
import Checkbox from '../../components/checkbox/checkbox';
import YearGroupLabel from '../../components/year-group-label/year-group-label';

const StudentBox = ({ student, onChange }) => (
    <div className={`${css['student-box']} ${student.selected ? css.selected : ''}
    ${student.disabled ? css.disabled : ''} ${student.isMovedCopied ? css['prev-selected'] : ''}`} >
        <Checkbox
            data={{ type: 'plain', selected: student.selected }}
            callback={originalData => onChange(student, !originalData.selected)}
            disabled={student.disabled}
        />
        <div className={css['student-name']}>{student.fullName}</div>
        <YearGroupLabel yearGroup={student.year}>{student.yearText}</YearGroupLabel>
    </div>
);

StudentBox.propTypes = {
    student: PropTypes.object,
    onChange: PropTypes.func
};

export default styleable(css)(StudentBox);



// WEBPACK FOOTER //
// ./components/student-box/student-box.js